export const fields = new Set(['environment','method','growth','grafted','pollination','goal','seedType','foliage','form','variegated','species','climate','age','cornGroup']);
export function validateRule(rule) {
  if (!rule || typeof rule !== 'object') throw new Error('Invalid rule');
  if (rule.op === 'all' || rule.op === 'any') {
    if (!Array.isArray(rule.rules) || !rule.rules.length) throw new Error('Empty rule');
    rule.rules.forEach(validateRule); return true;
  }
  if (!fields.has(rule.field) || !['eq','in','exists'].includes(rule.op)) throw new Error('Invalid field/operator');
  if (rule.op === 'in' && (!Array.isArray(rule.value) || !rule.value.length)) throw new Error('Invalid values');
  if (rule.op === 'eq' && !['string','number','boolean'].includes(typeof rule.value)) throw new Error('Invalid value');
  return true;
}
export function evaluateRule(rule, context) {
  validateRule(rule);
  if (rule.op === 'all' || rule.op === 'any') {
    const results = rule.rules.map(r => evaluateRule(r, context));
    if (rule.op === 'all') return results.includes('does_not_match') ? 'does_not_match' : results.includes('unknown') ? 'unknown' : 'matches';
    return results.includes('matches') ? 'matches' : results.includes('unknown') ? 'unknown' : 'does_not_match';
  }
  const value = context[rule.field];
  if (value === undefined || value === null || value === 'unknown' || value === '') return 'unknown';
  return (rule.op === 'exists' || (rule.op === 'eq' ? value === rule.value : rule.value.includes(value))) ? 'matches' : 'does_not_match';
}
export function resolveAction(action, context) {
  const variant = (action.variants || []).find(v => evaluateRule(v.when, context) === 'matches');
  return variant ? {...action, ...variant.content, variantId:variant.id} : {...action, variantId:'base'};
}
export function resolvePhase(phase, context) {
  const variant = (phase.variants || []).find(v => evaluateRule(v.when, context) === 'matches');
  const result = variant ? {...phase, ...variant.content} : phase;
  const skipped = phase.skipWhen && evaluateRule(phase.skipWhen, context) === 'matches';
  return {...result, skipped:!!skipped, actions:skipped ? [] : result.actions.map(a=>resolveAction(a,context))};
}
export function readinessResult(criteria, answers) {
  if (criteria.some(c => answers[c.id] === 'no')) return 'есть препятствие';
  if (!criteria.length || criteria.some(c => answers[c.id] !== 'yes')) return 'не хватает данных';
  return 'условия подходят';
}
export function localDate(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
}
